import axios from "axios";
import {detailServicesPath} from "../../../Constants";
import {log} from "three/src/nodes/math/MathNode";

const detailControllerRestUrl = detailServicesPath + '/customers/order-edges'

export default class OrderEdgeController {
    static async getAll(orderId) {
        const params = !!orderId ? "" : "&sample=true"
        return axios.get(`${detailControllerRestUrl}/by-order-id?orderId=${orderId || 0}${params}`);
    }

    static async get(orderEdgeId) {
        return axios.get(`${detailControllerRestUrl}/${orderEdgeId}`);
    }

    static async save(orderId, data) {
        const params = !!orderId ? "" : "&sample=true"
        return await axios.post(`${detailControllerRestUrl}?orderId=${orderId || 0}${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(orderEdgeId) {
        return await axios.delete(`${detailControllerRestUrl}/${orderEdgeId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(orderId, orderEdgeId, data) {
        return await axios.put(`${detailControllerRestUrl}/${orderEdgeId}?orderId=${orderId || 0}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
